/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

/**
 * Constants class mit den Namen der States der verschiedenen pages (mehrheitlich des Gesuchswizard).
 */
export class PageNameConstants {

    public readonly BEMERKUNG = 'bemerkung';
    public readonly GESUCHERSTELLEN = 'gesucherstellen';
    public readonly SCHADENMELDUNG = 'schadenmeldung';
    public readonly SCHADEN = 'schaden';
    public readonly ABSCHLUSS = 'abschluss';
    public readonly AUFWAENDE = 'aufwaende';
    public readonly SCHAETZUNG = 'schaetzung';
    public readonly EIGENLEISTUNGEN = 'eigenleistungen';
    public readonly VORLEISTUNG = 'vorleistung';
    public readonly FREMDKOSTEN = 'fremdkosten';
    public readonly ENTSCHAEDIGUNG = 'entschaedigung';
    public readonly BEITRAG = 'beitrag';
    public readonly VERSICHERUNGSBEITRAGSCHADEN = 'versicherungsbeitragschaden';
    public readonly BANKKONTO = 'bankkonto';
}



// WEBPACK FOOTER //
// ./src/app/core/service/PageNameConstants.ts